import {Component, HostListener, Input} from "@angular/core";
import {FUIEventsService} from "../events/events.service";

@Component({
    selector: "fui-page",
    templateUrl: "./page.component.html",
    styleUrls: ["./page.component.scss"]
})
export class FUIPageComponent {
    @Input() public description: string;
    @Input() public title: string;

    constructor(
        private eventsService: FUIEventsService) {
    }

    /**
     * Trap click-outside events
     * @param {MouseEvent} event
     */
    @HostListener("click", ["$event"])
    public click(mouseEvent: MouseEvent) {
        mouseEvent.stopPropagation();
        this.eventsService.click = mouseEvent;
    }

    @HostListener("mousedown", ["$event"])
    public mousedown(mouseEvent: MouseEvent): void {
        mouseEvent.stopPropagation();
        this.eventsService.click = mouseEvent;
    }

    /**
     * Track scrolling events for the modal
     * @param {Event} event
     */
    @HostListener("scroll", ["$event"])
    public scroll(event: Event) {
        event.stopPropagation();
        this.eventsService.scroll = event;
    }
}
